export default {"src":"/_next/static/media/7-icon.30f7d283.svg","height":41,"width":46,"blurWidth":0,"blurHeight":0};